module.exports = __webpack_public_path__ + "static/media/concert1.d47d1112.jpg";